import type { GalleryItemDto } from '../application/dto/GalleryDto';
import './GalleryGrid.css';

export interface GalleryGridProps {
  items: GalleryItemDto[];
  onItemClick: (index: number) => void;
}

/**
 * Renders thumbnails with native `loading="lazy"` — no external lazy-load
 * library needed, consistent with the "no additional frameworks" rule.
 */
export function GalleryGrid({ items, onItemClick }: GalleryGridProps) {
  if (items.length === 0) {
    return <p className="dma-gallery-grid__empty">موردی برای نمایش وجود ندارد.</p>;
  }

  return (
    <div className="dma-gallery-grid">
      {items.map((item, index) => (
        <button
          key={item.id}
          type="button"
          className="dma-gallery-grid__item"
          onClick={() => onItemClick(index)}
          aria-label={item.caption || 'مشاهده‌ی تصویر'}
        >
          <img src={item.thumbnailUrl} alt={item.caption} loading="lazy" />
          {item.type === 'video' ? <span className="dma-gallery-grid__play-icon">▶</span> : null}
        </button>
      ))}
    </div>
  );
}
